'use client';

/**
 * Contacto API helper — frontend client for the public contact endpoint
 * (SPEC-139 P-222 Opción A).
 *
 * Endpoint: `POST /api/contacto`
 * Auth: NONE (public — no JWT). Uses `auth: false` so `apiFetch` skips
 *       the access-token header (the endpoint accepts anonymous traffic).
 * Rate limit: 5/hour/IP (enforced server-side via `contactoLimiter`).
 *
 * The endpoint returns `{ message: string, emailDelivery: 'pending' }`
 * with HTTP 200. The `emailDelivery: 'pending'` flag signals to the UI
 * that real email delivery to soporte@profileia.com is deferred until
 * PENDIENTE-FOUNDER #26 (SMTP configuration).
 *
 * Spec ref: docs/SPEC-139-QA-SITE-SPRINT63-P222-P227.md §4 (Footer links fix).
 *
 * Anti-P-023: returns real values (message string) for the caller to render.
 * Anti-P-041: 0 `as any` casts.
 * Anti-P-042: 0 `console.*` statements.
 */
import { apiFetch } from './api-client';

export type ContactoTipo = 'general' | 'status' | 'bug';

export interface ContactoBody {
  nombre: string;
  email: string;
  asunto: string;
  tipo: ContactoTipo;
  mensaje: string;
}

export interface ContactoResult {
  message: string;
  code?: string;
  emailDelivery?: 'pending';
}

/**
 * Submit a contact message (Centro de Ayuda / Status del Sistema /
 * Reportar un Bug). Throws `ApiClientError` on 4xx/5xx so the caller
 * can render the error.
 */
export async function sendContactoMessage(body: ContactoBody): Promise<ContactoResult> {
  return apiFetch<ContactoResult>('/contacto', {
    method: 'POST',
    auth: false,
    body: JSON.stringify(body),
  });
}
